/* global fetch */
import { logWarning, trace } from './log';

const serviceMarketingPublicRoot = `/api/marketing`;
const checkCampaignEndpoint = `${serviceMarketingPublicRoot}/check`;
const ackCampaignEndpoint = `${serviceMarketingPublicRoot}/ack`;

export const checkCampaign = async (payload = {}) => {
  trace(`checkCampaign > calling ${checkCampaignEndpoint}`);
  const response = await fetch(checkCampaignEndpoint, {
    body: JSON.stringify(payload),
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
      // 'x-csrf-token': window.Cookies.get('csrf')
    }
  });

  if (response.ok) {
    trace(`checkCampaign > response is ok`);
    return response.json();
  }

  logWarning('checkCampaign: response not ok');
  throw new Error();
};

export const ackCampaign = async (campaignId) => {
  const ackUrl = `${ackCampaignEndpoint}/${campaignId}`;
  trace(`ackCampaign > calling ${checkCampaignEndpoint}`);
  const response = await fetch(ackUrl, {
    method: 'DELETE',
    credentials: 'same-origin',
    headers: {
      'Accept': 'text/html',
      'Content-Type': 'application/json'
    }
  });

  if (response.ok) {
    console.log('hello:');
    trace(`ackCampaign > response is ok`);
    return;
  }

  logWarning('ackCampaign: response not ok');
  throw new Error();
};
